 <!--page starts-->
    <section class="page-wrapper">
      <div class="ashton-hero-top-history cf" [ngStyle]="{'background-image':'url(' + historySingle?.detail?.thumbnail_image + ')'}">
      	<div class="container">
      	   <div class="ashton-hero-top-history-detail cf">
      	   	   <div class="ashton-hero-top-history-detail-inner ">
	      	   	   <div class="ashton-hero-top-history-image">
	      	   	   	   <img src="assets/images/Bitmap-icon.png">
	      	   	   </div>
	      	   	   <h2>{{historySingle?.detail?.title}}</h2>
	      	   	</div>
      	   </div> 	
      	</div>
      	<div class="ashton-hero-top-clubsponsorship-overlay"></div>
      </div>
      <div class="ashton-hero-top-history-content cf">
      	<div class="container">
      		<div class="ashton-hero-top-history-gallery cf">
      			<ngx-slick-carousel class="carousel " #slickModal="slick-carousel" [config]="slidegalleryConfig">
	      			<div ngxSlickItem class="ashton-hero-top-history-gallery-box slide" *ngFor="let gallery of historySingle?.detail?.images">
	      				<img [src]="gallery?.image">
	      			</div>
	      			<!-- <div ngxSlickItem class="ashton-hero-top-history-gallery-box slide">
	      				<img src="assets/images/news-single-bg.png">
	      			</div>
	      			<div ngxSlickItem class="ashton-hero-top-history-gallery-box slide">
	      				<img src="assets/images/news-single-bg.png">
	      			</div> -->
	      		</ngx-slick-carousel>
      		</div>
      		<div class="ashton-hero-top-history-content-detail" [innerHTML]="historySingle?.detail?.description">
			</div>
		</div>
      </div>
      <div class="ashton-hero-center-history-section cf">
      	<div class="container">
      		<div class="ashton-hero-center-history-detail-more cf">
      			<div class="ashton-hero-center-history-titel">
      				<h2>more</h2>
      			</div>
      			<div class="ashton-hero-center-history-arrow">
      				<a href="javascript:void(0);" class=""></a>
      			</div>
      		</div>
      	  	<div class="ashton-hero-center-history-detail">
      	  		<div class="ashton-hero-center-history-box">
      	  			<div class="ashton-hero-center-history-box-image">
      	  				<div class="ashton-hero-center-history-box-content">
	      	  				<h2>Hurst FC;<br> 20th century boys</h2>
	      	  			</div>
      	  			</div>
      	  		</div>
      	  		<div class="ashton-hero-center-history-box">
      	  			<div class="ashton-hero-center-history-box-image">
      	  				<div class="ashton-hero-center-history-box-content">
	      	  				<h2>Hurst FC;<br> 20th century boys</h2>
	      	  			</div>
      	  			</div>
      	  		</div>
      	  		<div class="ashton-hero-center-history-box">
      	  			<div class="ashton-hero-center-history-box-image">
      	  				<div class="ashton-hero-center-history-box-content">
	      	  				<h2>Hurst FC;<br> 20th century boys</h2>
	      	  			</div>
      	  			</div>
      	  		</div>
      	  		<div class="ashton-hero-center-history-box">
      	  			<div class="ashton-hero-center-history-box-image">
      	  				<div class="ashton-hero-center-history-box-content">
	      	  				<h2>Hurst FC;<br> 20th century boys</h2>
	      	  			</div>
      	  			</div>
      	  		</div>
      	  		<div class="ashton-hero-center-history-box">
      	  			<div class="ashton-hero-center-history-box-image">
      	  				<div class="ashton-hero-center-history-box-content">
	      	  				<h2>Hurst FC;<br> 20th century boys</h2>
	      	  			</div>
      	  			</div>
      	  		</div>
      	  	</div>
      	  	
      	</div>
      </div>
    </section><!-- page ends -->
    
